import restService from './rest.service'

function getRegistros() {
    return restService.postAsync('app/getRegistros');
}

function getResultados(date) {
    return restService.postAsync('app/getResultados', date);
}

function getLaudo(atendimento) {
    return restService.downloadAsync(`app/getLaudo/${atendimento.ateCod}`, {
        mime: 'application/pdf',
        title: `Laudo_${atendimento.ateCod}.pdf`
    })
}

function getResultadosFiltro(filtro) {
    return restService.postAsync('app/getResultadosFiltro', filtro);
}

export default { getRegistros, getResultados, getResultadosFiltro, getLaudo }